import { Parser } from '@json2csv/plainjs'

const serializeToCsv = (data, fields) => {
  const parser = new Parser({ fields })

  return parser.parse(data)
}

export default serializeToCsv
